module.exports = __webpack_public_path__ + "img/bg-footer.c8990ef5.png";